var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.options.editable !== false) ? _c('div', [_vm._l((_vm.current), function(item, index) {
    return _c('div', {
      key: index
    }, [(_vm.editIndex == index) ? _c('div', {
      staticClass: "list_editing"
    }, [_c('Input', {
      ref: ("input_" + index),
      refInFor: true,
      staticStyle: {
        "width": "260px"
      },
      attrs: {
        "suffix": "ios-return-left",
        "placeholder": _vm.options.placeholder || ''
      },
      on: {
        "on-enter": function($event) {
          return _vm.saveItem(item, index)
        },
        "on-blur": function($event) {
          return _vm.saveItem(item, index)
        }
      },
      model: {
        value: (_vm.current[index]),
        callback: function($$v) {
          _vm.$set(_vm.current, index, $$v)
        },
        expression: "current[index]"
      }
    })], 1) : _c('div', {
      staticClass: "list jcsb"
    }, [_c('div', {
      staticClass: "nowrap",
      staticStyle: {
        "width": "200px"
      },
      on: {
        "click": function($event) {
          return _vm.toEdit(index)
        }
      }
    }, [_vm._v(_vm._s(item))]), _vm._v(" "), _c('div', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeItem(index)
        }
      }
    }, [_c('Icon', {
      staticStyle: {
        "color": "#20bf64"
      },
      attrs: {
        "type": "ios-remove-circle"
      }
    })], 1)])])
  }), _vm._v(" "), (!_vm.options.max || _vm.current.length < _vm.options.max) ? _c('Input', {
    ref: "input",
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "suffix": "ios-add",
      "placeholder": _vm.options.placeholder || ''
    },
    on: {
      "on-enter": _vm.addItem
    },
    model: {
      value: (_vm.form.value),
      callback: function($$v) {
        _vm.$set(_vm.form, "value", $$v)
      },
      expression: "form.value"
    }
  }) : _vm._e()], 2) : _c('div', _vm._l((_vm.current), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "list"
    }, [_vm._v("\n            " + _vm._s(item) + "\n        ")])
  }), 0)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63d97895","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/TextList.vue
// module id = a9CP
// module chunks = 138